var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import "blocks/SportScoreboards/ui/SportScoreboards.less";
import { SportScoreboardComponents } from "../../../contracts";
const mapCommandToComponent = (props) => {
    const Scoreboard = SportScoreboardComponents[props.command];
    return Scoreboard && React.createElement(Scoreboard, Object.assign({}, props.data));
};
let SportScoreboards = class SportScoreboards extends React.Component {
    constructor(props) {
        super(props);
        this.state = props.dataProvider;
    }
    render() {
        return (React.createElement(React.Fragment, null, this.state.isLoaded &&
            React.createElement("section", { className: "rj-sport-scoreboard__container" }, mapCommandToComponent(this.state.boardData))));
    }
};
SportScoreboards = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], SportScoreboards);
export { SportScoreboards };
//# sourceMappingURL=SportScoreboards.js.map